module.exports = __webpack_public_path__ + "img/dmd_dragontokens.f9e6f47.png";